// @flow
export const getFileText = (file: React.Ref<any>): string => {
  try {
    if (!file?.current?.children) {
      return '';
    }

    const lines = Array.from(file.current.children);
    // Get the text content from each line and add a newline if not the last line or a \n
    return lines
      .map((l, i) =>
        l.textContent === '\n' || i === lines.length - 1
          ? l.textContent
          : `${l.textContent}\n`,
      )
      .join('');
  } catch {
    return '';
  }
};
